import React from 'react';
// import { makeStyles } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';

const AfitdPagination = props => {
    const { isHidden, disablePage, ...otherProps } = props;
    const { page, count } = props;
    // const classes = useStyles();

    if (isHidden) {
        return null;
    } else {
        const renderItem = disablePage
            ? {
                  renderItem: item => {
                      const type = item.type;
                      const itemDisabled = (type !== 'previous' && type !== 'next') || (type === 'previous' && page === 1) || (type === 'next' && page === count);
                      return <PaginationItem {...item} disabled={itemDisabled} />;
                  },
              }
            : {};
        return <Pagination {...renderItem} {...otherProps} />;
    }
};

export default AfitdPagination;
